import seedrandom from 'seedrandom';
export function getParticipationFromQueryString(queryString, param) {
    const params = new URLSearchParams(queryString);
    const value = params.get(param);
    if (value) {
        const [testName, variantName] = value.split(':');
        if (testName && variantName) {
            return { [testName]: variantName };
        }
    }
    return;
}
export const countryGroupMatches = (targetedCountryGroups = [], countryGroupId) => {
    if (targetedCountryGroups.length === 0) {
        return true;
    } // no targeting
    else {
        return targetedCountryGroups.includes(countryGroupId);
    }
};
export function randomNumber(mvtId, seed) {
    const rng = seedrandom(mvtId + seed);
    return Math.abs(rng.int32());
}
